import { cx } from '@linaria/core';
import { useState, useEffect } from 'react';
import { useAppContext, appContext, stringifyPublisher } from '@provider/app-context';
import { useUserIdentityState } from '@provider/user-identity';
import { wrapper } from './print.footer.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

function PrintFooter() {
  const user = useUserIdentityState(state => state.user);
  const publisher = useAppContext(state => state.publisher);
  const product = useAppContext(state => state.product);
  const course = useAppContext(state => state.course);
  const [authors, setAuthors] = useState();
  useEffect(() => {
    appContext.getPageAuthors().then(setAuthors).catch(() => {
      /** no-op */
    });
  }, []);
  const publisherLabel = stringifyPublisher(publisher);
  const productLabel = product?.subject ? `${product.subject}${product.gradesLabel ? ` ${product.gradesLabel}` : ""}${product.classLabel ? ` ${product.classLabel}` : ""}` : product?.title;
  return /*#__PURE__*/jsxs("footer", {
    "aria-hidden": true,
    className: cx(wrapper, "printFooter"),
    children: [course && product && /*#__PURE__*/jsxs(Fragment, {
      children: ["Fra ", course?.title, (authors?.length ?? 0) > 0 && /*#__PURE__*/jsxs(Fragment, {
        children: [" af ", authors?.join(", ")]
      }), ",", " ", productLabel, ", ", publisherLabel, /*#__PURE__*/jsx("br", {})]
    }), "Print og kopiering af dette materiale er tilladt, forudsat at det sker i overensstemmelse med skolens aftale med Tekst & Node.", /*#__PURE__*/jsx("br", {}), "Dette arbejdsark er udskrevet ", user && /*#__PURE__*/jsxs(Fragment, {
      children: ["af ", user.name]
    }), ", GYLDENDAL A/S,", " ", new Date().toLocaleDateString("da-DK", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    })]
  });
}

export { PrintFooter };
//# sourceMappingURL=print.footer.js.map
